import posthog from 'posthog-js';

const projectToken = import.meta.env.VITE_POSTHOG_PROJECT_TOKEN?.trim();

export const posthogEnabled = !!projectToken;

if (projectToken) {
  posthog.init(projectToken, {
    api_host: import.meta.env.VITE_POSTHOG_HOST || 'https://us.i.posthog.com',
    defaults: '2026-05-30',
    autocapture: false,
    capture_pageview: false, // captured on route change in AppShell
    capture_pageleave: false,
    capture_exceptions: false,
    disable_session_recording: true,
    person_profiles: 'identified_only',
    mask_all_text: true,
    mask_all_element_attributes: true,
    persistence: 'localStorage',
  });

  posthog.register({
    facetflow_service: 'ff-crm-web',
    release_version: import.meta.env.VITE_APP_RELEASE?.trim() || 'local',
    deployment_environment: import.meta.env.VITE_DEPLOYMENT_ENV?.trim() || import.meta.env.MODE || 'development',
  });
}

export { posthog };
